<template>
  <div class="show-more">
    <a
      href="#"
      class="show-more__opener"
      @click.prevent="show = !show"
    >
      {{ show ? hideText : openText }}
    </a>
    <transition name="fade">
      <div
        v-show="show"
        class="show-more__content"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'show-more',
  props: {
    openText: {
      default: 'Show More',
      type: String,
    },
    hideText: {
      default: 'Hide',
      type: String,
    },
  },
  data () {
    return {
      show: false,
    };
  },
};
</script>
<style lang="scss" scoped>
.show-more {
  * + & { margin-top: 1em; }

  font-size: 16px;
  line-height: 24px;

  &__opener {
    font-weight: 500;
    text-decoration: underline;
  }
}
</style>
